import { Box } from '@mui/material'
import LeadershipHeroSection from '../../components/leadership/LeadershipHeroSection'
import LeadershipIntroSection from '../../components/leadership/LeadershipIntroSection'
import LeadershipWhySection from '../../components/leadership/LeadershipWhySection'
import ProgramSkillsSection from '../../components/programs/ProgramSkillsSection'
import ProgramGallerySection from '../../components/programs/ProgramGallerySection'
import ProgramTestimonialsSection from '../../components/programs/ProgramTestimonialsSection'
import LeadershipStatsSection from '../../components/leadership/LeadershipStatsSection'
import LeadershipInitiativesSection from '../../components/leadership/LeadershipInitiativesSection'
import { leadershipSkills, leadershipGallery } from '../../data/leadershipContent'
import { homeTestimonials } from '../../data/homeContent'

import { programSectionGap, programSectionWrapperSx } from '../../components/programs/programLayout'
import { mobileSectionPy } from '../../theme/mobileLayout'

export default function LeadershipDevelopmentPage() {
  return (
    <Box sx={{ bgcolor: '#fffefa' }}>
      <LeadershipHeroSection />

      <Box sx={{ ...programSectionWrapperSx, pb: programSectionGap }}>
        <Box
          sx={{
            maxWidth: 1520,
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: programSectionGap,
          }}
        >
          <LeadershipIntroSection />
          <LeadershipWhySection />
          <ProgramSkillsSection title="Key Skills We Develop" skills={leadershipSkills} />
          <LeadershipStatsSection />
        </Box>
      </Box>

      <Box sx={{ pb: programSectionGap }}>
        <LeadershipInitiativesSection />
      </Box>

      <Box sx={{ ...programSectionWrapperSx, pb: programSectionGap }}>
        <Box sx={{ maxWidth: 1520, mx: 'auto' }}>
          <ProgramGallerySection
            images={leadershipGallery}
            alwaysShowLoadMore
            loadMoreLink="/events"
          />
        </Box>
      </Box>

      <Box sx={{ pb: programSectionGap }}>
        <ProgramTestimonialsSection testimonials={homeTestimonials} />
      </Box>
    </Box>
  )
}
